import React from 'react';
import '../styles/pages/WebsitePricing.css';

const WebsitePricing = () => {
  return (
    <div className="website-pricing-page">
      <div className="container">
        <header className="page-header">
          <h1>Wycena Strony Internetowej dla Firmy OperatorKredytowy</h1>
          <p>Profesjonalna strona na WordPress z gotowym szablonem premium</p>
        </header>

        <div className="info-box">
          <p><strong>Ważne informacje:</strong> Niniejsza wycena została przygotowana dla strony finansowej zawierającej wszystkie wymagane elementy zgodnie ze specyfikacją. Realizacja w ciągu 1 miesiąca od podpisania umowy. Wszystkie ceny podane są w PLN netto (bez VAT).</p>
        </div>

        <div className="package">
          <div className="ribbon"><span>Najlepsza oferta</span></div>
          <h3>Kompleksowy Pakiet Strony Finansowej</h3>
          
          <div className="package-price">5 400 zł</div>
          <div className="package-price-note">cena netto</div>
          
          <h3>Zawartość pakietu:</h3>
          <ul>
            <li><strong>Strona główna</strong> z przejrzystą prezentacją oferty, korzyściami dla klienta ("Szybka decyzja", "Minimum formalności", "Wsparcie ekspertów") i wyraźnymi wezwaniami do działania</li>
            <li><strong>9 podstron produktowych</strong> (Kredyty gotówkowe, Kredyty konsolidacyjne, Kredyty dla Firm, Kredyty hipoteczne, Leasingi, Produkty pozabankowe, Upadłość konsumencka, Sankcje Kredytu Darmowego, Doradztwo finansowe)</li>
            <li><strong>Podstrona "O nas / Nasza misja"</strong> z sekcjami: doświadczenie, licencje i certyfikaty, zespół, misja firmy, partnerzy bankowi</li>
            <li><strong>Podstrona "Opinie klientów"</strong> z możliwością dodawania własnych ocen</li>
            <li><strong>Podstrona "Kontakt"</strong> z formularzem, danymi teleadresowymi, mapą dojazdu, godzinami pracy i linkami do mediów społecznościowych</li>
            <li><strong>Podstrona "Zaufaj nam"</strong> zawierająca regulamin serwisu, politykę prywatności (RODO), informacje o przetwarzaniu danych osobowych i zastrzeżenia prawne</li>
            <li><strong>Podstrona "Obecność lokalna"</strong> z informacją o obsługiwanych regionach i zdjęciem siedziby</li>
            <li><strong>Podstrona FAQ</strong> z odpowiedziami na najczęstsze pytania klientów</li>
            <li><strong>Formularze kontaktowe</strong> na wszystkich podstronach produktowych</li>
            <li><strong>Szybki wniosek</strong> - prosty formularz z polami: imię, numer telefonu i rodzaj kredytu</li>
            <li><strong>Integracja z WhatsApp</strong> do szybkiego kontaktu</li>
            <li><strong>Możliwość pobierania dokumentów</strong> (PDF z listą wymaganych załączników)</li>
            <li><strong>Responsywny design</strong> - dostosowanie do urządzeń mobilnych</li>
            <li><strong>Podstawowa optymalizacja SEO</strong></li>
            <li><strong>Szkolenie z obsługi</strong> (1 godzina) + dostęp do materiałów wideo</li>
          </ul>
        </div>

        <h2>Szczegółowa wycena realizacji</h2>
        
        <div className="table-container">
          <table className="price-table">
            <thead>
              <tr>
                <th>Usługa</th>
                <th>Opis</th>
                <th>Koszt (PLN)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Przygotowanie i analiza</td>
                <td>Analiza potrzeb, konkurencji i słów kluczowych, omówienie struktury</td>
                <td className="price-column">600</td>
              </tr>
              <tr>
                <td>Zakup i konfiguracja szablonu</td>
                <td>Zakup licencji premium + dostosowanie do potrzeb klienta</td>
                <td className="price-column">800</td>
              </tr>
              <tr>
                <td>Instalacja i konfiguracja WordPress</td>
                <td>Instalacja CMS, konfiguracja pluginów, zabezpieczenia</td>
                <td className="price-column">500</td>
              </tr>
              <tr>
                <td>Strona główna</td>
                <td>Zaprojektowanie strony głównej z sekcjami prezentacji oferty, korzyściami dla klienta i wezwaniami do działania</td>
                <td className="price-column">800</td>
              </tr>
              <tr>
                <td>Podstrony produktowe (9 szt.)</td>
                <td>Kredyty gotówkowe, hipoteczne, konsolidacyjne, dla firm, leasing, produkty pozabankowe, upadłość konsumencka, sankcje kredytu darmowego, doradztwo finansowe</td>
                <td className="price-column">1 500</td>
              </tr>
              <tr>
                <td>Podstrony dodatkowe (5 szt.)</td>
                <td>O nas, kontakt, opinie, strona prawna, obecność lokalna, FAQ</td>
                <td className="price-column">800</td>
              </tr>
              <tr>
                <td>Formularze kontaktowe</td>
                <td>Wdrożenie formularzy kontaktowych i szybkiego wniosku na wszystkich podstronach produktowych</td>
                <td className="price-column">400</td>
              </tr>
              <tr>
                <td>Optymalizacja SEO</td>
                <td>Podstawowa optymalizacja treści pod słowa kluczowe, meta tagi</td>
                <td className="price-column">500</td>
              </tr>
              <tr>
                <td>Szkolenie i materiały</td>
                <td>Szkolenie z obsługi CMS (1h) + dostęp do materiałów wideo</td>
                <td className="price-column">400</td>
              </tr>
              <tr className="total-row">
                <td colSpan="2">RAZEM</td>
                <td className="price-column">5 400</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>Opcje dodatkowe</h2>
        
        <div className="table-container">
          <table className="options-table">
            <thead>
              <tr>
                <th>Opcja</th>
                <th>Opis</th>
                <th>Koszt (PLN)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Dodanie dodatkowej podstrony</strong></td>
                <td>Stworzenie dodatkowej podstrony oferty wraz z tekstami i materiałami graficznymi.</td>
                <td>170</td>
              </tr>
              <tr>
                <td><strong>Kalkulator kredytowy</strong></td>
                <td>Interaktywny kalkulator kredytowy z możliwością wyboru rodzaju kredytu, kwoty, okresu spłaty i wyliczania miesięcznej raty</td>
                <td>Do ustalenia</td>
              </tr>
              <tr>
                <td><strong>Sklep internetowy</strong></td>
                <td>Dodanie modułu e-commerce do strony (WooCommerce) z możliwością sprzedaży produktów finansowych, ebooków, kursów online</td>
                <td>1 500</td>
              </tr>
              <tr>
                <td><strong>Rebranding loga</strong></td>
                <td>Projekt 3 propozycji nowego logo firmy z księgą znaku i plikami w różnych formatach (JPG, PNG, SVG, PDF)</td>
                <td>350</td>
              </tr>
              <tr>
                <td><strong>Pozycjonowanie strony</strong></td>
                <td>Pozycjonowanie strony w wyszukiwarkach, optymalizacja on-site i off-site, budowa linków, miesięczny raport</td>
                <td>1 500 - 3 500 / miesiąc*</td>
              </tr>
              <tr>
                <td><strong>Integracja z CRM</strong></td>
                <td>Połączenie formularzy z wybranym systemem CRM</td>
                <td>800</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p><small>* Cena pozycjonowania zależy od ilości linków, artykułów na bloga i innych działań SEO</small></p>
        
        <h2>Harmonogram realizacji</h2>
        
        <div className="timeline">
          <div className="timeline-container left">
            <div className="timeline-content">
              <h3>Tydzień 1</h3>
              <p>Analiza potrzeb, research, przygotowanie struktury strony, dobór szablonu WordPress, instalacja i konfiguracja CMS</p>
            </div>
          </div>
          <div className="timeline-container right">
            <div className="timeline-content">
              <h3>Tydzień 2</h3>
              <p>Konfiguracja szablonu, przygotowanie strony głównej, implementacja pierwszych podstron produktowych</p>
            </div>
          </div>
          <div className="timeline-container left">
            <div className="timeline-content">
              <h3>Tydzień 3</h3>
              <p>Dokończenie podstron produktowych, implementacja podstron dodatkowych (O nas, Kontakt, Opinie, Regulamin)</p>
            </div>
          </div>
          <div className="timeline-container right">
            <div className="timeline-content">
              <h3>Tydzień 4</h3>
              <p>Finalizacja wszystkich elementów, optymalizacja SEO, testowanie funkcjonalności, szkolenie, publikacja strony</p>
            </div>
          </div>
        </div>
        
        <h2>Warunki płatności</h2>
        
        <ul>
          <li><strong>50% kwoty</strong> przed rozpoczęciem prac</li>
          <li><strong>50% kwoty</strong> po finalnym odbiorze i publikacji strony</li>
        </ul>
      </div>
    </div>
  );
};

export default WebsitePricing;